/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useActions } from 'common/hooks/useActions';
import AppSwitch from 'components/form/switch';
import ImageUploader from 'components/form/imageUploader';
import PanelBoxLayout from 'components/layout/panelBox';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import { useParams } from 'react-router';
import DropDown from 'components/form/dropDown';
import TextIput from 'components/form/textInput';
import FieldPair from 'components/form/fieldPair';
import { menuCategoryArray } from 'common/enums';
import Customization from './lib/customization';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function CafeteriaMenuManagementCreate() {
  const [isActive, setIsActive] = useState(false);
  const [image, setImage] = useState<any>();
  const [values, setValues] = useState<any>({
    title: '',
    category: null,
    fileUrl: '',
    image: '',
    imageName: '',
    translations: [
      {
        language: 'en',
        translate: ''
      },
      {
        language: 'ar',
        translate: ''
      }
    ]
  });

  const params = useParams();

  const { menuItem }: any = useTypedSelector((state) => state.Cafeteria);

  const { MenuManagementDetailRequestAction } = useActions();

  const renderCategoryName = (cat: string) => {
    let newText: string = '';
    // eslint-disable-next-line array-callback-return
    menuCategoryArray.map((item: any) => {
      if (item.id === cat) newText = item.title;
    });
    return newText;
  };

  useEffect(() => {
    if (params?.id) MenuManagementDetailRequestAction(params?.id);
  }, [params?.id]);

  useEffect(() => {
    if (params?.id && menuItem) {
      setValues({
        ...values,
        title: menuItem?.data?.list?.title,
        category: menuItem?.data?.list?.category,
        translations: [
          {
            language: 'en',
            translate: menuItem?.data?.list?.menuTranslations?.find((t: any) => t.language === 'en')?.translate || ''
          },
          {
            language: 'ar',
            translate: menuItem?.data?.list?.menuTranslations?.find((t: any) => t.language === 'ar')?.translate || ''
          }
        ]
      });
      setIsActive(menuItem?.data?.list?.status);
      setImage(menuItem?.data?.list?.image);
      return;
    }
    setImage(null);
  }, [menuItem, params?.id]);

  return (
    <S.Content>
      <PageTitle title="Menu Details" />

      {/*
       * Active belongs to the item, so it sits in the item's section head —
       * the design's right-hand slot — rather than floating above the card
       * with nothing under it. It used to be an antd Switch painted `#1DBAAF`
       * or `#FF6464` inline, beside an 18px label that said "InActive" in red:
       * a state rendered as though it were an error.
       */}
      <PanelBoxLayout
        title="Item details"
        info={<AppSwitch theme="two" checked={isActive} text="Active" onChange={() => setIsActive(!isActive)} />}
      >
        <S.Body>
          <S.FormHeaderContainer>
            <S.FormHeader>
              <DropDown
                label="Category"
                list={menuCategoryArray}
                onChange={(e) => setValues({ ...values, category: e?.id as any })}
                key={values.category}
                placeholder="Category"
                defaultValue={{
                  id: values.category,
                  title: renderCategoryName(values.category)
                }}
                disabled={!!params?.id}
              />

              <FieldPair>
                <TextIput
                  type="text"
                  name="en-title"
                  placeholder="Saudi Coffee"
                  value={values?.translations?.find((t: any) => t.language === 'en')?.translate || ''}
                  onChange={(e) => {
                    setValues({
                      ...values,
                      translations: values?.translations?.map((t: any) =>
                        t.language === 'en' ? { ...t, translate: e.target.value } : t
                      )
                    });
                  }}
                  label="Item title"
                  langTag="EN"
                  required
                />

                <TextIput
                  type="text"
                  name="ar-title"
                  placeholder="القهوة السعودية"
                  value={values?.translations?.find((t: any) => t.language === 'ar')?.translate || ''}
                  onChange={(e) => {
                    setValues({
                      ...values,
                      translations: values?.translations?.map((t: any) =>
                        t.language === 'ar' ? { ...t, translate: e.target.value } : t
                      )
                    });
                  }}
                  label="Item title"
                  langTag="AR"
                  required
                  dir="rtl"
                />
              </FieldPair>
            </S.FormHeader>

            <S.Uploader>
              <S.UploaderLabel>Image</S.UploaderLabel>
              <ImageUploader setImage={setImage} defaultImage={image} values={values} setValues={setValues} />
            </S.Uploader>
          </S.FormHeaderContainer>
        </S.Body>
      </PanelBoxLayout>

      <Customization
        selectedOptions={menuItem?.data?.list?.selectedOptions}
        btnTitle={values?.translations?.find((t: any) => t.language === 'en')?.translate || ''}
        title={values.translations}
        category={values.category}
        image={image}
        activeStatus={isActive}
        values={values}
      />
    </S.Content>
  );
}
